<template>
  <div>
    <el-dialog width="300px" title="添加家庭联系人" @close="setDialogClose" center :close-on-click-modal="false"
      :destroy-on-close="true" :visible.sync="showHomePatientDialog" append-to-body>
      <el-form :model="formData">
        <el-form-item label="关系">
          <el-select v-model="formData.relationCode" placeholder="请选择关系">
            <el-option v-for="(item, index) in relationNameData" :key="index" :value="item.value"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showHomePatientDialog = false">关闭</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  addContactList,
  getSysDicList
} from "@/api/health/Patients";
export default {
  data() {
    return {
      showHomePatientDialog: false,
      formData: {
        relationCode: null,
        relationName: null,
      },
      listQuery: null,
      parentInfo: null,
      relationNameData: [],
    }
  },
  methods: {
    // 开启弹窗
    async init(row, parentInfo) {
      this.showHomePatientDialog = true;
      this.listQuery = row;
      this.parentInfo = parentInfo;
      console.log("listQuery:", this.listQuery, this.parentInfo)

      var typeData = "家庭关系代码";
      this.getSystemDictList(typeData);
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.relationNameData = records;
      }).catch(err => {
        console.log(err);
      })
    },
    // 关闭弹窗
    setDialogClose() {
      this.formData.relationName = null;
      this.showHomePatientDialog = false;
    },
    getRelation(code) {
      var option = this.relationNameData.filter(v => v.value == code)[0];
      return option.name;
    },
    // 提交新建联系人成员 
    submitForm() {
      if (!this.formData.relationCode) {
        this.$message({
          message: "请选择联系人关系！",
          type: "error"
        })
        return;
      }

      var contactParams = {
        idcard: this.listQuery.idcard,
        name: this.listQuery.name,
        phone: this.listQuery.phone,
        relationCode: this.formData.relationCode,
        relationName: this.getRelation(this.formData.relationCode),
        householderIdcard: this.parentInfo.idcard
      };
      addContactList(contactParams).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "新建联系人成功！",
            type: "success"
          })
        }
        this.showHomePatientDialog = null;
        this.$emit("updateHomeList")
      }).catch(err => {
        console.log(err);
      })
    }
  }
}
</script>